import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';

interface ListHeaderTitleProps {
  sortName?: string;
  sortDesc?: boolean;
  sortKey?: string;
  setSortName?: (value: string) => void;
  setSortDesc?: (value: boolean) => void;
  onClick?: () => void;
  children: ReactNode;
}

export const ListHeaderTitle = ({
  sortName,
  sortDesc,
  sortKey,
  setSortName,
  setSortDesc,
  onClick,
  children,
}: ListHeaderTitleProps) => {
  const handleSorting = (name: string) => {
    setSortDesc && setSortDesc(false);
    setSortName && setSortName(name);
    if (sortName === name) {
      setSortDesc && setSortDesc(!sortDesc);
    }
  };

  return (
    <Typography
      component="div"
      variant="subheader2"
      color="text.secondary"
      noWrap
      onClick={() => (!!onClick ? onClick() : !!sortKey && handleSorting(sortKey))}
      sx={{
        cursor: !!onClick || !!sortKey ? 'pointer' : 'default',
        display: 'inline-flex',
        alignItems: 'center',
      }}
    >
      {!!sortKey && (
        <Box sx={{ display: 'inline-flex', flexDirection: 'column', ml: 1 }}>
          <KeyboardArrowUpRoundedIcon
            fontSize="small"
            sx={{
              position: 'relative',
              marginBottom: '-6px',
              color: sortName === sortKey && sortDesc
                ? '#D3D3DE'
                : '#4F4F63',
            }}
          />
          <KeyboardArrowDownRoundedIcon
            fontSize="small"
            sx={{
              position: 'relative',
              marginTop: '-6px',
              color: sortName === sortKey && !sortDesc
                ? '#D3D3DE'
                : '#4F4F63',
            }}
          />
        </Box>
      )}

      {children}
    </Typography>
  );
};
